import SovosIconButton from "../../sovos-icon-button";
import { elementOfPropType } from "../utils/reactHelpers";
export default elementOfPropType(SovosIconButton);